<abs-messages>
  <div class="alert b2b-alerts-messages b2b-alerts-info valign-children-middle" tabindex="-1"
    [ngClass]="{'d-none':!showInfo}" [abs-trap-focus-inside-element]="false" *ngIf="showInfo">
    <div class="alert-info">
      <em class="icon-flat-info" role="img" aria-label="Info"></em>
    </div>
    <div id="title" class="title h3">
      <p *ngFor="let message of messages" [innerHTML]="message"></p>
      <p>
        <a abs-accessibility-click="13,32" #hyperLink
          (click)="registerNow(showInfoLink.anchorLink); sonarFix('hyperLink')">{{showInfoLink.anchorText}}</a>
      </p>
    </div>
    <button *ngIf="!showHideCloseIcon" type="button" class="close" aria-label="dismiss" #closeBtn
      (click)="toggle('showInfo')"></button>
  </div>
</abs-messages>